import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initImageTooltips() {
  const globalTooltip = document.querySelector('#global-cursor-tooltip');
  const canHover = window.matchMedia('(hover: hover)').matches;
  const isTouch = !canHover;

  /* ---------------------------------------------
   * SHARED UTIL
   * --------------------------------------------- */
  const getStyleClass = (el) =>
    [...el.classList].find(c => c.startsWith('tp-'));

  /* ---------------------------------------------
   * MOBILE: LOCAL TOOLTIP (SCROLL BASED)
   * --------------------------------------------- */
  function initMobileTooltips() {
    const items = document.querySelectorAll('.image-with-tooltip');

    items.forEach(item => {
      const tipText = item.dataset.tip;
      if (!tipText) return;

      const tooltip = document.createElement('div');
      tooltip.className = 'local-mobile-tooltip';
      tooltip.textContent = tipText;

      const styleClass = getStyleClass(item);
      if (styleClass) tooltip.classList.add(styleClass);

      item.appendChild(tooltip);

      gsap.fromTo(
        tooltip,
        { autoAlpha: 0, y: 12 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.4,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: item,
            start: 'center 70%',
          }
        }
      );
    });
  }

  /* ---------------------------------------------
   * DESKTOP: GLOBAL FOLLOWER
   * --------------------------------------------- */
  function initDesktopTooltip() {
    if (!globalTooltip) return;

    let mouseX = 0;
    let mouseY = 0;
    let activeTarget = null;

    const xSetter = gsap.quickSetter(globalTooltip, 'x', 'px');
    const ySetter = gsap.quickSetter(globalTooltip, 'y', 'px');

    gsap.set(globalTooltip, {
      autoAlpha: 0,
      scale: 1.3,
      transformOrigin:"center",
      pointerEvents: 'none'
    });

    window.addEventListener('mousemove', e => {
      mouseX = e.clientX + 16;
      mouseY = e.clientY + 16;
    });

    gsap.ticker.add(() => {
      xSetter(mouseX);
      ySetter(mouseY);
    });

    document.addEventListener('mouseover', e => {
      const target = e.target.closest('.image-with-tooltip');
      if (!target || target === activeTarget) return;

      const tipText = target.dataset.tip;
      if (!tipText) return;

      activeTarget = target;
      globalTooltip.textContent = tipText;

      globalTooltip.className =
        globalTooltip.className.replace(/\btp-\S+/g, '');
      const styleClass = getStyleClass(target);
      if (styleClass) globalTooltip.classList.add(styleClass);

      gsap.fromTo(globalTooltip, {
        autoAlpha: 0,
        scale: 1.3,

      }, {
        autoAlpha: 1,
        scale: 1,
        duration: .3,
        ease: 'power2.inOut',
        overwrite: true
      });
    });

    document.addEventListener('mouseout', e => {
      if (!e.relatedTarget?.closest('.image-with-tooltip')) {
        activeTarget = null;
        gsap.to(globalTooltip, {
          autoAlpha: 0,
          scale: 1.3,
          duration: 0.1,
          ease: 'power2.out'
        });
      }
    });
  }

  /* ---------------------------------------------
   * CLICK HANDLER (SAFE)
   * --------------------------------------------- */
function initClickHandler() {
  document.addEventListener('click', e => {

    // 1️⃣ If user clicked a real link or button → do nothing
    if (e.target.closest('a, button')) return;

    // 2️⃣ Then check for tooltip container
    const container = e.target.closest('.image-with-tooltip');
    if (!container || e.defaultPrevented) return;

    const url = container.dataset.url;

    if (url && url !== '#') {
      window.location.assign(url);
    }
  });
}


  /* ---------------------------------------------
   * INIT
   * --------------------------------------------- */
  if (isTouch) {
    initMobileTooltips();
  } else {
    initDesktopTooltip();
  }

  initClickHandler();
}
